module.exports = __webpack_public_path__ + "img/coamisal.45992b9c.jpg";